function dueTone(task, now) {
  if (!task || !task.due_at) {
    return "muted";
  }
  const dueAt = new Date(task.due_at);
  if (Number.isNaN(dueAt.getTime())) {
    return "muted";
  }
  if (dueAt.getTime() < now.getTime()) {
    return "overdue";
  }
  const dayMs = 24 * 60 * 60 * 1000;
  if (dueAt.getTime() - now.getTime() <= dayMs) {
    return "stale";
  }
  return "ready";
}

function dueLabel(task, tone) {
  if (!task || !task.due_at) {
    return "No due date";
  }
  return tone === "overdue" ? "Overdue" : tone === "stale" ? "Due soon" : "Scheduled";
}

export function buildFollowUpTaskWorkspace(options = {}) {
  const settings = Object.assign(
    {
      tasks: [],
      members: [],
      currentUser: null,
      now: new Date().toISOString(),
    },
    options
  );
  const tasks = Array.isArray(settings.tasks) ? settings.tasks : [];
  const members = Array.isArray(settings.members) ? settings.members : [];
  const now = new Date(settings.now || new Date().toISOString());
  const openTasks = tasks.filter((item) => item.status !== "completed");
  const overdueTasks = openTasks.filter((item) => dueTone(item, now) === "overdue");
  const dueSoonTasks = openTasks.filter((item) => dueTone(item, now) === "stale");
  const currentUser = settings.currentUser || null;
  const assigneeOptions = [];
  const seen = new Set();
  for (const item of [...members, currentUser].filter(Boolean)) {
    if (!item.user_id || seen.has(item.user_id)) {
      continue;
    }
    seen.add(item.user_id);
    assigneeOptions.push({
      user_id: item.user_id,
      label: item.full_name ? `${item.full_name}${item.role ? ` - ${item.role}` : ""}` : item.email || item.user_id,
    });
  }

  return {
    summaryCards: [
      {
        label: "Open follow-ups",
        value: String(openTasks.length),
        detail: openTasks.length ? "Tasks still need action." : "No open reminders for this contact.",
        tone: openTasks.length ? "ready" : "muted",
      },
      {
        label: "Overdue",
        value: String(overdueTasks.length),
        detail: overdueTasks.length ? "Immediate follow-up attention required." : "No overdue follow-ups.",
        tone: overdueTasks.length ? "overdue" : "ready",
      },
      {
        label: "Due soon",
        value: String(dueSoonTasks.length),
        detail: dueSoonTasks.length ? "These reminders are due within 24 hours." : "Nothing due soon.",
        tone: dueSoonTasks.length ? "stale" : "muted",
      },
    ],
    taskRows: (openTasks.length ? openTasks : tasks)
      .slice(0, 6)
      .map((task) => {
        const tone = dueTone(task, now);
        return {
          id: task.id,
          label: task.title || task.task_type || "Workflow task",
          value: dueLabel(task, tone),
          tone,
          meta: `${task.priority || "normal"} priority | ${task.assigned_user_id || "unassigned"} | ${task.due_at || "no due date"}`,
          status: task.status || "open",
          notes: task.notes || "",
        };
      }),
    assigneeOptions,
  };
}
